import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { ActionPlansContext } from "context/ActionPlansContext";
import UserService from "services/UserService";
import { putActionPlan, getActionPlan } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  AutocompleteInput,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  LocalizationAutocomplete,
  TextInput,
} from "components/Input/Index.js";
import EditButton from "components/CustomButtons/EditButton";
import { planActions } from "variables/planActions";

const arrGoals = [
  "electricityobjconsumption",
  "gasobjconsumption",
  "waterobjconsumption",
  "heatnetworkobjconsumption",
  "coldnetworkobjconsumption",
  "fuelobjconsumption",
  "woodobjconsumption",
  "propaneobjconsumption",
];

export default function GoalsEdit({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;

  const [newGoals, setNewGoals] = useState();

  console.log(newGoals);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   console.log(e.target);
  //   setNewGoals((prevState) => ({
  //     ...prevState,
  //     [params]: { ...prevState.goals, [name]: value },
  //   }));
  // };

  const handleChange = (e, goal) => {
    const { name, value } = e.target;
    console.log(e.target, goal);
    setNewGoals((prevState) => ({
      ...prevState,
      [params]: {
        ...prevState.goals,
        [goal]: { ...prevState.goals?.[goal], [name]: value },
      },
    }));
  };

  useEffect(() => {
    //setNewGoals({ actionplan: actionPlans.id });
    console.log("actionPlans");
    setNewGoals(actionPlans?.parameters || {});
  }, [actionPlans]);

  const urlPlanAction = getActionPlan(actionPlans.id);

  let url = putActionPlan(actionPlans.id);

  const handleSubmit = (event) => {
    createActionGoals(event);
  };

  const createActionGoals = async (event) => {
    console.log(newGoals);

    axios
      .put(url, newGoals, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setActionPlans((prevState) => ({
            ...prevState,
            parameters: newGoals,
          }));
          setNotification("success", "Objectifs modifiée");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  // const unitList = [
  //   {
  //     name: planActions["goalsUnits"][goal],
  //     id: planActions["goalsUnits"][goal],
  //   },
  //   { name: "%", id: "percent" },
  // ];

  return (
    <>
      <GridContainer>
        {arrGoals.map((goal) => {
          return (
            <>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <FloatInput
                  inputTitle={planActions[params][goal]}
                  floatInput={newGoals?.[params]?.[goal]?.value || ""}
                  handleFloatInputChange={(e) => handleChange(e, goal)}
                  name="value"
                  disabled={!actionplanadmin}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3} lg={3}>
                <CustomSelect
                  inputTitle={"Unité"}
                  selectValue={newGoals?.[params]?.[goal]?.unit || ""}
                  handleSelectValueChange={(e) => handleChange(e, goal)}
                  data={[
                    {
                      name: planActions["goalsUnits"][goal],
                      id: planActions["goalsUnits"][goal],
                    },
                    { name: "% éco", id: "percent" },
                  ]}
                  name="unit"
                  disabled={!actionplanadmin}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3} lg={3}>
                <DateInput
                  inputTitle={"date jalon"}
                  dateInput={newGoals?.[params]?.[goal]?.date || ""}
                  handleDateInputChange={(e) => handleChange(e, goal)}
                  specialType={"month"}
                  name="date"
                  disabled={!actionplanadmin}
                />
              </GridItem>
            </>
          );
        })}
      </GridContainer>
      {actionplanadmin && (
        <GridContainer>
          <GridItem
            xs={12}
            sm={6}
            md={7}
            lg={7}
            style={{ marginLeft: "8px", marginTop: "12px" }}
          >
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
